import React, { useCallback, useContext } from 'react';

import { DefinitionListContext } from '../../page.context';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload, FormDialog } = useContext(DefinitionListContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <FormDialog open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
